export default {
  // META
  'meta.title': 'Reas.cz',
  'meta.description':
    'Reas vám umožní prodat nemovitost rychle, jednoduše, online. Prodáváte nemovitost? Získejte bezplatnou nabídku. Zdarma a bez závazků.',
  'meta.og.title': 'Reas - nejsnadnější cesta, jak prodat nemovitost',
  'meta.og.description':
    'Reas vám umožní prodat nemovitost rychle, jednoduše, online. Prodáváte nemovitost? Získejte bezplatnou nabídku. Zdarma a bez závazků.',

  // HOTLINE
  hotline_work_hours: 'Po - Pá   (09:00 - 17:00)',

  // NAV

  'nav.links.sell': 'Prodat',
  'nav.links.buy': 'Koupit',
  'nav.links.estimate_price': 'Odhad ceny',
  'nav.links.atlas': 'Atlas cen',
  'nav.links.statistics': 'Statistiky',
  'nav.links.blog': 'Blog',

  'nav.links.logout': 'Odhlásit se',

  'nav.cta': 'Zavolejte mi',
  'nav.open': 'Menu',
  'nav.close': 'Zavřít',
  'nav.link.beta': 'BETA',

  // FOOTER
  'footer.company_info':
    'Ostrovní 126/30<br></br>Praha - Nové Město<br></br>PSČ 110 00',
  'footer.copyright': '© 2016 - {year} Reas',
  'footer.support.title': 'Nevíte si rady?',
  'footer.support.subtitle': 'Ozvěte se nám',

  // FOOTER LINKS
  'footer.links.reas': 'Reas.cz',
  'footer.links.about': 'O nás',
  'footer.links.blog': 'Blog',
  'footer.links.reviews': 'Recenze',
  'footer.links.contact': 'Kontakt',

  'footer.links.estate_sale': 'Prodej nemovitosti',
  'footer.links.instant_offer': 'Okamžitá platba',
  'footer.links.atlas': 'Atlas cen',
  'footer.links.flat_prices': 'Ceny bytů',
  'footer.links.estimate_price': 'Odhad ceny',

  'footer.links.co_operation': 'Spolupráce',
  'footer.links.for_estate_brokers': 'Pro makléře',
  'footer.links.for_buyers': 'Pro kupující',
  'footer.links.for_press': 'Pro novináře',
  'footer.links.jobs': 'Kariéra v Reas.cz',

  'footer.links.terms_and_conditions': 'Obchodní podmínky',
  'footer.links.privacy': 'Ochrana osobních údajů',
  'footer.links.cookies': 'Cookies',

  'footer.links.facebook': 'Najdete nás na',

  // CTA SECTION NEW
  'section.cta.title': 'Za 2 minuty',
  'section.cta.subtitle': 'do nejbližší realitky nejspíš nedojdete',
  'section.cta.perex':
    'Vyplnit náš formulář ale stihnete. Získáte tím zdarma představu o ceně i odhad, za jak dlouho se nemovitost prodá.',
  'section.cta.button': 'Spočítat odhad ceny',

  // BLOG
  'section.related_posts.title': 'Mohlo by vás zajímat',
  'section.related_posts.full_article': 'Číst článek',

  // SURVEY
  'survey.send': 'Odeslat',
  'survey.next_step': 'Pokračovat',
  /**
   * survey steps
   */
  // locality
  'survey.locality': 'Lokalita',
  'survey.locality.title':
    'Přemýšlíte o prodeji nemovitosti?<br></br>Zadejte, kde se nachází',
  'survey.locality.subtitle':
    'Klikněte na kraj a vyberte okres, ve kterém se vaše nemovitost nachází.',
  'survey.city': 'Město',
  'survey.address': 'Ulice a číslo popisné',
  'survey.locality_address.title': 'Zadejte, kde se nemovitosti nachází.',
  'survey.locality_address.subtitle':
    'Vyplňte ulici s číslem popisným a následně město.',
  // estate
  'survey.estate_type': 'Typ nemovitosti',
  'survey.estate_type.title': 'O jaký typ nemovitosti se jedná?',
  'survey.estate_type.subtitle':
    'Vyberte typ nemovitosti, u které chcete znát prodejní cenu.',
  // flat
  'survey.estate.flat_construction_type': 'Stavba',
  'survey.estate.flat_disposition': 'Dispozice',
  'survey.estate.estate_condition': 'Stav objektu',

  'survey.estate.estate_condition.very_good.flat':
    'Jedná se o byt po kompletní rekonstrukci nebo novostavbu? Byty ve velmi dobrém stavu vypadají jako nové a nevyžadují žádné finanční prostředky do oprav. Mají obvykle novou kuchyň i koupelnu.',
  'survey.estate.estate_condition.good.flat':
    'Byt má už něco za sebou, ale stále je v nejlepších letech. Není nutné žádných nákladných investic popř. jen investic do drobných oprav nebo výměny vybavení kuchyně popř. koupelny.',
  'survey.estate.estate_condition.bad.flat':
    'Jedná se o nemovitost vhodnou k rekonstrukci popř. vyžadující si nákladných investic. Renovace koupelny, kuchyně, topení, vody nebo elektrických rozvodů bude nezbytná.',

  'survey.estate.estate_condition.very_good.house':
    'Dům nevyžaduje žádné další investice a je v perfektní kondici. Může se jednat o novostavbu nebo dům po rekonstrukci.',
  'survey.estate.estate_condition.good.house':
    'Objekt je v dobrém stavu, ale už je třeba menších investic do oprav opotřebovaných částí domu, oprav fasády, střechy nebo vnitřního vybavení domu.',
  'survey.estate.estate_condition.bad.house':
    'Je nutná velká investice do opravy, zateplení, rekonstrukce interiérů atd. Může se jednat o objekt určený k rekonstrukci.',

  'survey.estate.flat_floor': 'Patro',
  'survey.estate.flat_living_area': 'Rozměr',
  'survey.estate.estate_amenities': 'Příslušenství',
  'survey.estate.flat_ownership': 'Druh',
  'survey.estate.flat_ownership.description':
    'Pokud je byt ve vlastnictví firmy, zvolte prosím osobní vlastnictví.',
  'survey.estate.house_rooms_count': 'Počet pokojů',
  'survey.estate.house_type': 'Typ budovy',
  'survey.estate.house_purpose': 'Využití',
  'survey.estate.estate_land_area': 'Plocha pozemku (nepovinné)',
  'survey.estate.estate_land_area.description':
    'Celková plocha pozemku tak, jak je zapsaná v katastru nemovitostí.',
  'survey.estate.house_build_up_area': 'Zastavěná plocha (nepovinné)',
  'survey.estate.house_build_up_area.description':
    'Jedná se o součet všech zastavěných ploch jednotlivých staveb. Počítá se plocha tvořena pravoúhlými průměty obvodových stěn vč. plochy lodžií a arkýřů, které jsou nad zemí.',
  'survey.estate.house_living_area': 'Obytná plocha (nepovinné)',
  'survey.estate.house_living_area.description':
    'Jedná se o součet plochy všech místností v domě, které jsou určeny k celoročnímu obývání. Jsou větrány a přímo osvětleny. Jedná se o všechny pokoje, ložnici, obývací pokoj, pracovnu nebo kuchyň a další místnosti, které mají plochu alespoň 8 m<sup>2</sup>. Nepatří sem chodba, schodiště, balkon, atd.',
  'survey.estate.house_floors_count': 'Počet nadzemních podlaží',
  'survey.estate.estate_other': 'Další informace',
  'survey.estate.other.estate_other': 'Jakou nemovitost vlastníte?',
  'survey.estate.land_purpose': 'Typ',
  'survey.estate.price_estimate': 'Jakou máte cenovou představu?',
  'survey.estate.sell_horizon': 'V jakém časovém horizontu chcete prodat?',
  // contact
  'survey.contact': 'Kontakt',
  'survey.contact.title': 'Pro získání nabídky vyplňte kontaktní údaje',
  'survey.contact.subtitle':
    'Zbavte se starostí. Zjistěte nezávazně z naší nabídky, jak jednoduše nemovitost prodáte.',
  'survey.submit': 'Odeslat',
  'survey.terms':
    'Odesláním formuláře souhlasím s <a href="/obchodni-podminky" target="_blank">obchodními podmínkami</a> a se <a href="/ochrana-osobnich-udaju" target="_blank">zpracováním osobních údajů</a>.',
  'survey.contact.tooltip': 'Téměř hotovo',

  // ESTATE TYPES
  'estate_type.flat': 'Byt',
  'estate_type.house': 'Dům',
  'estate_type.commercial_object': 'Komerční objekt',
  'estate_type.other': 'Jiné',
  'estate_type.land': 'Pozemek',

  // FORM VALIDATIONS
  'validation.invalid': 'Neplatná hodnota',
  'validation.required': 'Vyplňte prosím toto pole',
  'validation.required.address': 'Vyplňte prosím ulici a číslo popisné',
  'validation.required.city': 'Vyplňte prosím město nebo obec',
  'validation.required.address_city': 'Vyplňte prosím ulici a město nebo obec',
  'validation.required.estate_type': 'Vyberte prosím typ nemovitosti',
  'validation.required.flat_construction_type': 'Vyberte prosím typ konstrukce',
  'validation.required.flat_disposition': 'Vyberte prosím dispozici',
  'validation.required.estate_condition': 'Vyberte prosím stav objektu',
  'validation.required.flat_floor': 'Vyberte prosím patro',
  'validation.required.house_living_area': 'Vyberte prosím rozměr',
  'validation.required.estate_amenities': 'Vyberte prosím příslušenství',
  'validation.required.flat_ownership': 'Vyberte prosím druh vlastnictví',
  'validation.required.house_rooms_count': 'Vyberte prosím počet pokojů',
  'validation.required.house_type': 'Vyberte prosím typ budovy',
  'validation.required.estate_land_area': 'Vyberte prosím plochu pozemku',
  'validation.required.house_build_up_area': 'Vyberte prosím zastavěnou plochu',
  'validation.house_build_up_area.larger_then_estate_land_area':
    'Zastavěná plocha musí být menší než plocha pozemku',
  'validation.required.estate_floors_count': 'Vyberte prosím počet podlaží',
  'validation.required.estate_other': 'Vyplňte prosím další informace',
  'validation.required.other.estate_other':
    'Vyplňte prosím jakou nemovitost vlastníte',
  'validation.required.price_estimate': 'Vyplňte prosím cenovou představu',
  'validation.required.sell_horizon':
    'Vyplňte prosím časový horizont, ve kterém chcete prodat',
  'validation.required.full_name': 'Vyplňte prosím jméno',
  'validation.required.email': 'Vyplňte prosím e-mail',
  'validation.required.phone_number': 'Vyplňte prosím telefon',
  'validation.required.message': 'Vyplňte prosím zprávu',
  'validation.email': 'Vyplňte prosím platný e-mail',
  'validation.phone_number':
    'Vyplňte prosím platný telefon (např. ve tvaru 777888999, nebo +420 777 888 999)',
  'validation.phone_number.invalid': 'Telefon je ve špatném tvaru',
  'validation.required.subscriptionRadius': 'Zvolte prosím okruh sledování cen',
  'validation.required.subscriptionAddress':
    'Zadejte adresu lokality, kterou chcete sledovat, ve formátu např. Jankovcova 45 nebo Praha Holešovice.',
  'validation.min': 'Hodnota nesmí být menší než {value}.',

  // ESTATE PINNED FEAT LABELS
  'estate_flat_disposition.label': 'Dispozice',
  'estate_house_disposition.label': 'Počet pokojů',
  'estate_flat_floor_area.label': 'Užitná plocha',
  'estate_house_living_area.label': 'Užitná plocha',
  'estate_land_area.label': 'Výměra',
  'estate_construction_type.label': 'Stavba',
  'estate_condition.label': 'Stav',
  'estate_house_purpose.label': 'Typ domu',
  'estate_land_type.label': 'Typ pozemku',
  'estate_amenities.label': 'Vybavení',

  // flat construction
  'flat_construction.brick': 'Cihla',
  'flat_construction.panel': 'Panel',
  'flat_construction.other': 'Jiné',

  // flat disposition
  'flat_disposition.1+kk': '1+kk',
  'flat_disposition.1+1': '1+1',
  'flat_disposition.2+kk': '2+kk',
  'flat_disposition.2+1': '2+1',
  'flat_disposition.3+kk': '3+kk',
  'flat_disposition.3+1': '3+1',
  'flat_disposition.4+kk': '4+kk',
  'flat_disposition.4+1': '4+1',
  'flat_disposition.4+1_and_larger': '4+1 a větší',
  'flat_disposition.larger': '5+kk a větší',

  // estate condition
  'estate_condition.very_good': 'Velmi dobrý',
  'estate_condition.good': 'Dobrý',
  'estate_condition.bad': 'Špatný',

  // flat condition
  'flat_condition.new_building': 'Novostavba',
  'flat_condition.after_reconstruction': 'Po rekonstrukci',
  'flat_condition.good': 'Dobrý stav',
  'flat_condition.for_reconstruction': 'K rekonstrukci',

  // building and rooms condtion
  'condition.bad': 'Špatný',
  'condition.good': 'Dobrý',
  'condition.newish': 'Zánovní',
  'condition.excellent': 'Výborný',

  // flat floor
  'flat_floor.ground_floor': 'Přízemí',
  'flat_floor.second_and_higher_floors_without_lift': '2. a vyšší s výtahem',
  'flat_floor.second_and_higher_floors_with_lift': '2. a vyšší bez výtahu',

  // flat vicinity
  'flat_vicinity.quiet': 'Tiché a klidné',
  'flat_vicinity.common': 'Běžné',
  'flat_vicinity.loud': 'Rušné',

  // flat ownership
  'flat_ownership.private': 'Osobní',
  'flat_ownership.collective': 'Družstevní',

  // house rooms count
  'house_rooms_count.1': '1',
  'house_rooms_count.2': '2',
  'house_rooms_count.3': '3',
  'house_rooms_count.4': '4',
  'house_rooms_count.5_or_more': '5 a více',

  // house type
  'house_type.brick': 'Zděná',
  'house_type.wooden_building': 'Dřevostavba',
  'house_type.villa': 'Vila',
  'house_type.cottage': 'Chalupa',
  'house_type.hut': 'Chata',
  'house_type.other': 'Jiné',

  // house purpose
  'house_purpose.family': 'Rodinný',
  'house_purpose.recreation': 'Rekreační',
  'house_purpose.other': 'Jiné',

  // land type
  'land_type.housing': 'Bydlení',
  'land_type.commercial': 'Komerční',
  'land_type.agricultural': 'Zemědělské',
  'land_type.gardens': 'Zahrady',
  'land_type.meadows': 'Louky',
  'land_type.orchard_vineyards': 'Sady',
  'land_type.ponds': 'Rybníky',
  'land_type.other': 'Ostatní',

  // sale horizon
  'sell_horizon.asap': 'Co nejdříve',
  'sell_horizon.less_than_6_months': 'Do 6 měsíců',
  'sell_horizon.7_months_and_later': 'Později',

  // contact
  'contact.name': 'Jméno a příjmení',
  'contact.email': 'E-mail',
  'contact.email.placeholder': 'Zadejte váš e-mail...',
  'contact.phone': 'Telefon',

  // unit
  square_meters: '{area}&nbsp;m²',
  'unit.square_meters': '&nbsp;m²',
  'unit.czk': 'Kč',

  // buyout offer horizon
  'buyout_offer_horizon.less_than_week': 'Do týdne',
  'buyout_offer_horizon.less_than_2_weeks': 'Do 2 týdnů',
  'buyout_offer_horizon.less_than_30_days': 'Do 30 dní',

  // transactions count
  'transactions_count.title':
    'Za loňský rok jsme zprostředkovali prodeje nemovitostí za více než ',

  // Months
  'month.0': 'leden',
  'month.1': 'únor',
  'month.2': 'březen',
  'month.3': 'duben',
  'month.4': 'květen',
  'month.5': 'červen',
  'month.6': 'červenec',
  'month.7': 'srpen',
  'month.8': 'září',
  'month.9': 'říjen',
  'month.10': 'listopad',
  'month.11': 'prosinec',

  // Datepicker
  'datepicker.input.default_placeholder': 'DD.MM.RRRR',

  // Pagination
  'pagination.items_per_page': 'Položek na stránku',

  building_type: 'Typ budovy',
  'building_type.apartment_building': 'Bytový dům',
  'building_type.housing': 'Objekt k bydlení',
  'building_type.family_house': 'Rodinný dům',
  'building_type.industrial_building': 'Průmyslový objekt',
  'building_type.farm_building': 'Zemědělská usedlost',
  'building_type.amenities': 'Objekt občanské vybavenosti',
  'building_type.forestry_building': 'Objekt lesního hospodářství',
  'building_type.recreational_building': 'Stavba pro rodinnou rekreaci',
  'building_type.gathering_building':
    'Stavba pro shromažďování většího počtu osob',
  'building_type.accommodation_building': 'Stavba ubytovacího zařízení',
  'building_type.warehouse': 'Stavba pro výrobu a skladování',
  'building_type.bussiness_building': 'Stavba pro obchod',
  'building_type.office_building': 'Stavba pro administrativu',
  'building_type.paraphernalia_building': 'Stavba technického vybavení',
  'building_type.agricultural_building': 'Zemědělská stavba',
  'building_type.transport_building': 'Stavba pro dopravu',
  'building_type.garage_building': 'Garáž',
  'building_type.other': 'Jiná stavba',
  'building_type.multifunctional_building': 'Víceúčelová stavba',
  'building_type.greenhouse': 'Skleník, pařeniště',
  'building_type.dam': 'Přehrada',
  'building_type.flood_barrier':
    'Hráz k ochraně nemovitostí před zaplavením při povodni',
  'building_type.river_dam': 'Hráz přehrazující vodní tok nebo údolí',
  'building_type.water_reservoir': 'Hráz ohrazující umělou vodní nádrž',
  'building_type.water_or_sailing_building':
    'Stavba k plaveb.účelům v korytech nebo na březích vod.toků',
  'building_type.hydropower_plant':
    'Stavba k využití vodní energie (vodní elektrárna)',
  'building_type.barrage': 'Jez',
  'building_type.tailings_dam': 'Stavba odkaliště',
  'building_type.unfinished': 'Rozestavěné jednotky',
  'building_type.unknown': 'Neznámý typ',

  // Parcel type
  'parcel_type.greenhouse': 'Skleník',
  'parcel_type.kindergarten': 'Školka',
  'parcel_type.tree_plantation': 'Plantáž dřevin',
  'parcel_type.forest': 'Les jiný než hospodářský',
  'parcel_type.forest_with_buildings': 'Lesní pozemek, na kterém je budova',
  'parcel_type.pond': 'Rybník',
  'parcel_type.natural_watercourse_bed':
    'Koryto vodního toku přirozené nebo upravené',
  'parcel_type.artificial_watercourse_bed': 'Koryto vodního toku umělé',
  'parcel_type.natural_water_dam': 'Vodní nádrž přírodní',
  'parcel_type.artificial_water_dam': 'Vodní nádrž umělá',
  'parcel_type.wet_area': 'Zamokřená plocha',
  'parcel_type.common_courtyard': 'Společný dvůr',
  'parcel_type.demolition_site': 'Zbořeniště',
  'parcel_type.track': 'Dráha',
  'parcel_type.highway': 'Dálnice',
  'parcel_type.road': 'Silnice',
  'parcel_type.other_communication': 'Ostatní komunikace',
  'parcel_type.other_transport_area': 'Ostatní dopravní plocha',
  'parcel_type.greenery': 'Zeleň',
  'parcel_type.sports_ground_and_recreational_area':
    'Sportoviště a rekreační plocha',
  'parcel_type.graveyard': 'Pohřebiště',
  'parcel_type.cultural_and_educational_area': 'Kulturní a osvětová plocha',
  'parcel_type.handling_area': 'Manipulační plocha',
  'parcel_type.mining_area': 'Dobývací prostor',
  'parcel_type.dump': 'Skládka',
  'parcel_type.other_area': 'Jiná plocha',
  'parcel_type.barren_land': 'Neplodná půda',
  'parcel_type.water_area': 'Vodní plocha, na které je budova',
  'parcel_type.photovoltaic_power_plant': 'Fotovoltaická elektrárna',
  'parcel_type.boundary': 'Mez, stráň',
  'parcel_type.unknown': 'Pozemek',

  // Parcel kind
  'parcel_kind.fertile_ground': 'Orná půda',
  'parcel_kind.hop_garden': 'Chmelnice',
  'parcel_kind.vineyard': 'Vinice',
  'parcel_kind.garden': 'Zahrada',
  'parcel_kind.orchard': 'Ovocný sad',
  'parcel_kind.pernament_grassland': 'Trvalý travní porost',
  'parcel_kind.forest_land': 'Lesní pozemek',
  'parcel_kind.water_area': 'Vodní plocha',
  'parcel_kind.builtup_area_and_courtyard': 'Zastavěná plocha a nádvoří',
  'parcel_kind.other_area': 'Ostatní plocha',
  'parcel_kind.unknown': 'Pozemek',

  // building & parcel number
  'building_number.house_number': 'č. p. {number}',
  'building_number.evidentional_number': 'ev. č. {number}',
  'building_number.without_number': '{number}',
  parcel_number: 'parc. č. {number}',

  // finished at year intervals
  'finished_at_interval.year_and_older': '{year} a starší',
  'finished_at_interval.year_and_newer': '{year} a novější',

  // unit types
  'unit_type.flat': 'Byt',
  'unit_type.commertial_space': 'Nebytový prostor',
  'unit_type.garage': 'Garáž',
  'unit_type.studio': 'Ateliér',
  'unit_type.workshop': 'Dílna',
  'unit_type.unfinished': 'Nedokončené',
  'unit_type.mixed': 'Skupina bytů a nebyt. prostor',
  'unit_type.mixed_commertial_spaces': 'Skupina nebyt. prostor',
  'unit_type.mixed_flats': 'Skupina bytů',
  'unit_type.unknown': 'Jednotka',

  'form.submission_failure':
    'Formulář se nepodařilo odeslat, zkuste to prosím za chvíli znovu.',

  something_failed: 'Došlo k chybě. Zkuste to prosím za chvíli znovu.',

  'select.default_placeholder': '- vyberte možnost',
  'select.validation.required': 'Vyberte prosím jednu z možností.',
  'select.default_clear': '- Obnovit původní údaj',

  'select.yes': 'Ano',
  'select.no': 'Ne',
  'select.maybe': 'Možná',

  // legal disclaimer
  legal_disclaimer:
    'Odesláním potvrzujete souhlas s našimi {termsLink} a se {privacyLink}.',
  'legal_disclaimer.terms_and_conditions': 'všeobecnými podmínkami',
  'legal_disclaimer.data_protection': 'zpracováním osobních údajů',

  ownership: 'vlastnictví', // used as suffix on offer result page
  'tooltip.vat.title': 'DPH',
  'tooltip.vat.content':
    'Na základě dostupných údajů předpokládáme, že součástí transakce bylo {vatPercentage}% DPH.',

  'submit.error':
    'Při odesílání informací došlo k chybě, zkuste to prosím znovu později.',

  change_options_choice: 'Chci změnit odpověď',

  'suggestion.city_with_district': '{city} (okres {district})',

  'filters.range_filter.from': 'Od',
  'filters.range_filter.to': 'do',
  'filters.range_filter.dismiss': 'Zrušit omezení',
  'filters.range_filter.submit': 'Hotovo',
};
